import React, { useCallback, useEffect, useRef, useState } from "react";
import styled from "styled-components";

const InputWrapper = styled.div`
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
  transition: 0.2s;
  box-shadow: ${({ isFocused }) =>
    isFocused ? "4.462px 4.462px 7.808px rgba(0, 0, 0, 0.12)" : "none"};

  :hover {
    box-shadow: 4.462px 4.462px 7.808px 0px rgba(0, 0, 0, 0.12);
  }
`;

const LessonTitleInput = styled.textarea`
  resize: none;
  min-height: 40px;
  max-height: 90px;
  width: 100%;
  padding: 8px 15px;
  font-size: 16px;
  line-height: 24px;
  color: #1e1e1e;

  ::-webkit-scrollbar {
    width: 3px;
  }
`;

const LessonTitle = ({ lessonSettingsData, setLessonSettingsData }) => {
  const lessonTitleInputRef = useRef(null);
  const [isFocused, setIsFocused] = useState(false);

  useEffect(() => {
    if (lessonTitleInputRef.current) {
      lessonTitleInputRef.current.style.height = "auto";
      lessonTitleInputRef.current.style.height =
        lessonTitleInputRef.current.scrollHeight + "px";
    }
  }, [lessonSettingsData.lesson_name, lessonTitleInputRef]);

  const handleLessonTitleInput = useCallback(
    (event) => {
      const newLessonName = event.target.value;

      setLessonSettingsData((prevState) => ({
        ...prevState,
        lesson_name: newLessonName,
      }));
    },
    [setLessonSettingsData]
  );

  return (
    <InputWrapper isFocused={isFocused}>
      <LessonTitleInput
        ref={lessonTitleInputRef}
        placeholder="Название урока"
        type="text"
        rows={1}
        value={lessonSettingsData.lesson_name || ""}
        onChange={handleLessonTitleInput}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
      />
    </InputWrapper>
  );
};

export default LessonTitle;
